<template>
  <div class="q-pa-md">
    
    <div class="introWindow q-pt-lg">
      <q-table
        :loading="isLoading"
        ref="table"
        title="profit Recommendations - Price Optimization"
        :data="data"
        :columns="columns"
        row-key="index"
        @row-click="onRowClick"
        no-data-label="No Result Found"
      >
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              v-for="col in columns"
              :key="col.name"
              :props="props"
              class="headerText"
              :style="{ fontSize: '15px', color: 'dodgerblue' }"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :props="props"
            class="cursor-pointer"
            @click.native="onRowClick(props.row)"
          >
            <q-td key="index" :props="props">
              {{
                props.row.index != null && props.row.index != undefined
                  ? props.row.index + 1
                  : "No data"
              }}
            </q-td>

            <q-td key="store_key" :props="props">
              {{
                props.row["Store Name"] != null && props.row["Store Name"] != undefined
                  ? props.row["Store Name"]
                  : "No data"
              }}
            </q-td>
            <q-td key="product_name" :props="props">
              {{
                props.row["Product Name"] != null && props.row["Product Name"]!= undefined
                  ? props.row["Product Name"]
                  : "No data"
              }}
            </q-td>

            <q-td key="MRP" :props="props">
              ₹
              {{
                props.row.MRP != null &&
                props.row.MRP != undefined
                  ? props.row.MRP.toFixed(2)
                  : "No data"
              }}
            </q-td>
            <q-td key="actual_selling_price" :props="props">
              ₹
              {{
                props.row["Selling Price(SP)"] != null &&
                props.row["Selling Price(SP)"] != undefined
                  ? props.row["Selling Price(SP)"].toFixed(2)
                  : "No data"
              }}
            </q-td>


             <q-td key="optimal_price" :props="props">
              ₹
              {{
                props.row["Recommended Price(RP)"] != null &&
                props.row["Recommended Price(RP)"] != undefined
                  ? props.row["Recommended Price(RP)"].toFixed(2)
                  : "No data"
              }}
            </q-td>

               
            <q-td key="actual_quantity" :props="props">
              {{
                props.row["Predicted Demand at SP"] != null &&
                props.row["Predicted Demand at SP"] != undefined
                  ? Math.trunc(props.row["Predicted Demand at SP"])
                  : "No data"
              }}
            </q-td>

            <q-td key="constr_demand" :props="props">
              {{
                props.row["Predicted Demand at RP"] != null && props.row["Predicted Demand at RP"] != undefined
                  ? props.row["Predicted Demand at RP"]
                  : "No data"
              }}
            </q-td>

            <q-td key="confidence_range" :props="props">
              <span v-if="'insufficient_data' === props.row.confidence_range"
                ><div class="box-i">
                  <strong>Insufficient Data</strong>
                </div>
              </span>
              <span
                v-if="
                  'high' === props.row.confidence_range ||
                  'very_high' === props.row.confidence_range
                "
                ><div class="box-h">
                  <strong>High</strong>
                </div>
              </span>
              <span v-if="'low' === props.row.confidence_range"
                ><div class="box-l">
                  <strong>Low</strong>
                </div>
              </span>
              <span v-if="'medium' === props.row.confidence_range"
                ><div class="box-m">
                  <strong>Medium</strong>
                </div></span
              >
            </q-td>

            <!-- <q-td key="item_key" :props="props">
              {{
                props.row.item_key != null && props.row.item_key != undefined
                  ? props.row.item_key
                  : "No data"
              }}
            </q-td> -->

            
             
            
            <q-td key="actual_profit" :props="props">
              ₹
              {{
                props.row["Predicted Profit at SP"]!= null &&
                props.row["Predicted Profit at SP"] != undefined
                  ? props.row["Predicted Profit at SP"].toFixed(2)
                  : "No data"
              }}
            </q-td>
            <q-td key="profit" :props="props">
              ₹
              {{
                props.row["Predicted Profit at RP"]!= null &&
                props.row["Predicted Profit at RP"] != undefined
                  ? props.row["Predicted Profit at RP"].toFixed(2)
                  : "No data"
              }}
            </q-td>
            


            
         


            <!-- <q-td key="end_stock" :props="props">
               {{(props.row.end_stock)!=null && (props.row.end_stock)!= undefined ?(props.row.end_stock).toFixed(2):"No data" }}
            </q-td> -->

            <q-td key="percentage_profit_increase" :props="props">
              {{
                 props.row["Percentage Profit Increase"] != null &&
                props.row["Percentage Profit Increase"] != undefined
                  ? props.row["Percentage Profit Increase"].toFixed(2)
                  : "No data"
              }}
              %
            </q-td>

            <!-- <q-td key="coefficient_of_variation" :props="props">
              {{(props.row.coefficient_of_variation)!=null && (props.row.coefficient_of_variation)!= undefined ?(props.row.coefficient_of_variation).toFixed(2):"No data" }} 
            </q-td> -->
          </q-tr>
        </template>
        <!-- 
            <template v-slot:bottom>
        <q-tr class="confidence_img">
        
             Confidence:<img src="https://img.icons8.com/emoji/28/fa314a/green-circle-emoji.png"/> High  <img src="https://img.icons8.com/emoji/28/000000/orange-circle-emoji.png"/> Medium  <img src="https://img.icons8.com/emoji/28/000000/red-circle-emoji.png"/>  Low
  
       
        </q-tr>
      </template> -->
      </q-table>
    </div>
  </div>
</template>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
/* .q-pa-md {
    padding: 8px 10px 8px 10px;
} */
.heading {
  font-family: "Montserrat", sans-serif;
  color:  blue;
  margin: 0.5rem;
}
.confidence_img {
  display: flex;
  align-items: center;
}
.introWindow {
  text-align: center;
  border-radius: 4px;
  padding: 1rem 1rem 0;
  
  /* background-image: radial-gradient(circle, #2678ca, #082f7a); */
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); */
  height: 100vh;
}
.box-i {
  align-items: center;
  background-color: #000000;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-h {
  align-items: center;
  background-color: #2db051;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-l {
  align-items: center;
  background-color: #e40017;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.box-m {
  align-items: center;
  background-color: #fb9300;
  color: white;
  display: flex;
  justify-content: center;
  height: 2rem;
  width: 7rem;
  position: relative;
  border-radius: 5px;
  margin: auto;
}
.errorClass {
  background: red;
}
.check {
  height: 1rem;
  margin-top: 1rem;
}
.priceOptButton {
  text-align: center;
  margin-top: 1rem;
}
.buttn {
  background: rgb(33, 103, 233);
  color: white;
  border-radius: 5px;
}
.buttn:hover {
  cursor: pointer;
}
.headerText {
  color: blue;
  font-weight: 800;
}

.fit{
   border-top-left-radius: 0px !important;
   border-bottom-right-radius: 0px !important;
   border-bottom-left-radius: 0px !important;
   background: white!important;
box-shadow: 0px 3px 6px #00000030;


}
</style>

<script>
export default {
  props: { jobid: String },
  data() {
    return {
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      errorcarbs: false,
      errorClassData: [],
      errorMessagecarbs: "",
      submitVisibliliy: true,
      backupList: [],
      columns: [
        {
          name: "index",
          required: true,
          label: "Index",
          align: "center",
          field: "index",
          classes: "bg-grey-2 ellipsis",
          style: "max-width: 100px",
          headerClasses: "bg-primary text-white",
          sortable: true,
        },
        {
          name: "store_key",
          label: "Store Name",
          field: "store_key",
          align: "center",
          sortable: true,
        },
        {
          name: "product_name",
          label: "Product Name",
          field: "product_name",
          align: "center",
          sortable: true,
        },
        {
          name: "MRP",
          label: "MRP",
          field: "MRP",
          align: "center",
        },
         {
          name: "actual_selling_price",
          label: "Selling Price(SP)",
          field: "actual_selling_price",
          align: "center",
        },
        
         {
          name: "optimal_price",
          label: "Recommended Price(RP)",
          field: "optimal_price",
          align: "center",
        },
        
        
        {
          name: "actual_quantity",
          label: "Predicted Demand at SP",
          field: "actual_quantity",
          align: "center",
        },
        {
          name: "constr_demand",
          label: "Predicted Demand at RP",
          field: "constr_demand",
          align: "center",
        },
        {
          name: "confidence_range",
          label: "Confidence Range",
          field: "confidence_range",
          align: "center",
        },
        // {
        //   name: "item_key",
        //   label: "Item",
        //   field: "item_key",
        //   align: "center",
        //   sortable: true,
        // },
        
        
       
        {
          name: "actual_profit",
          label: "Predicted Profit at SP",
          field: "actual_profit",
          align: "center",
        },
        {
          name: "profit",
          label: "Predicted Profit at RP",
          field: "profit",
          align: "center",
        },
       
        // { name: "end_stock", label: "End Stock", field: "end_stock",align: "center", },
        {
          name: "percentage_profit_increase",
          label: "Percentage Profit Increase",
          field: "percentage_profit_increase",
          align: "center",
        },
        // {
        //   name: "coefficient_of_variation",
        //   label: "Coefficient Of Variation",
        //   field: "coefficient_of_variation",
        //   align:"center",
        // },
      ],
      filter: "",
      data: [],
       currencySymbol:{
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BOV: 'BOV',
  BRL: 'R$',
  BSD: '$',
  BTC: '₿',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHE: 'CHE',
  CHF: 'CHF',
  CHW: 'CHW',
  CLF: 'CLF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  COU: 'COU',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'Ξ',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'Ł',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MXV: 'MXV',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: 'S$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYI: 'UYI',
  UYU: '$U',
  UYW: 'UYW',
  UZS: 'лв',
  VEF: 'Bs',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XSU: 'Sucre',
  XUA: 'XUA',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWD: 'Z$',
  ZWL: '$'
},
    };
  },
  created() {
 
      this.$q.loading.show({
       message: "Authenticating please wait..",
     });
      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/profit-recommendations");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
        this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/profit-recommendations");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else if(this.$cookies.isKey("login_authentication2"))
     {
       let encryptedText = this.$cookies.get("login_authentication2");
       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);
       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/priceoptimization/profit-recommendations");
        this.isAuthenticated = true;
       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
  
    //   var resultshistoryURL = this.api_url + "/resultshistory/volumeresults";
    // this.$http
    //   .get(resultshistoryURL)
    //   .then((response) => {
    //     let count=1;
    //     let result = response.data;
    //     // console.log(response.data);
    //     let data = result.map((items) => {
    //       return {
    //         ...items,
    //         jobnum: count++
    //       };
    //     });
    //     console.log(data);
    //     this.data = data;
    //     this.isLoading = false;
    //   })
    //   .catch((err) => {
    //     this.$q.notify({
    //       message: err,
    //       color: "negative",
    //     });
    //     this.isLoading = false;
    //     // console.log(err);
    //   });
  },
  mounted() {
    console.log(this.$route.params.jobid);
    var resultsURL =
      this.api_url +
      "/resultshistory/fetch_recommendations/" +
      this.$route.params.jobid;
    console.log(resultsURL);
    this.$http
      .get(resultsURL)
      .then((response) => {
        let result = response.data;
        let data = result;
        this.data = data;
        console.log(this.data);
        this.isLoading = false;
      })
      .catch((err) => {
        this.$q.notify({
          message: err,
          color: "negative",
        });
        this.isLoading = false;
        //console.log(err);
      });
  },
  methods: {
    onRowClick(row) {
      this.selected = row;
      console.log(this.selected);
      this.$router.push({
        name: "ProfitSummary",
        params: {
          items: row,
          jobid:this.$route.params.jobid
        },
      });
    },
  },
};
</script>